export default "__VITE_ASSET__BYJOtSQV__"